function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import BaseTemplatePage, { getSerializedServerProps, getServerSideProps as getBaseProps } from "../../generated-templates/base-template-page";
import PositionComponent from "components/pages/careers/position/position-component";
import ErrorCareersComponent from "components/pages/careers/error-careers-component/error-careers-component";
import { CAREERS_ERROR_RENDERED } from "constants/bigbrain-event-types";
import { trackBigBrainEventOnServer } from "server/services/bigbrain-tracking-service/bigbrain-tracking-service";
import { getPositionData, isPositionIdValid } from "components/pages/careers/careers-service";
import { POSITION_PAGE, UNLISTED_POSITION_ID } from "constants/careers/careers";
import { publishedPositionFitsType } from "server/services/comeet-service/position-type-service";
import { INTERNAL_SERVER_ERROR_CODE } from "constants/status-codes";
import { InternalServerError } from "server/extensions/error-extensions";
import * as Sentry from "@sentry/nextjs";
import { handleServerException } from "server/services/exceptions-handling-service/exceptions-handling-service";
import { getGeneratorSystemConfigOnRequest } from "server/services/request-service/request-service";
const PAGE_NOT_FOUND_ERROR = 404;
const PAGE_GONE_ERROR = 410;
function change404ErrorCodeIfNeeded(statusCode) {
    // Cloudfront automaticaly override all 404 responses with a custom page. In this case we want our error component
    return statusCode === PAGE_NOT_FOUND_ERROR ? PAGE_GONE_ERROR : statusCode;
}
function trackError(req, message) {
    trackBigBrainEventOnServer(CAREERS_ERROR_RENDERED, {
        kind: POSITION_PAGE,
        placement: req.url,
        info1: message,
        info2: req.params.id,
        directObject: req.hostname
    });
}
export function getServerSideProps(context) {
    return _getServerSideProps.apply(this, arguments);
}
function _getServerSideProps() {
    _getServerSideProps = _async_to_generator(function*(context) {
        const { handleServerException } = require("../../../server/services/exceptions-handling-service/exceptions-handling-service");
        const baseInitialProps = yield getBaseProps(context);
        const superInitialProps = baseInitialProps.props;
        const id = context.req.params.id === "unlisted" ? UNLISTED_POSITION_ID : context.req.params.id;
        const { positionsType } = context.query;
        if (!isPositionIdValid(id)) {
            Sentry.captureMessage(`Position id is invalid: ${id}`);
            return {
                props: {
                    translations: superInitialProps.translations,
                    PAGE_NOT_FOUND_ERROR
                }
            };
        }
        try {
            var _getGeneratorSystemConfigOnRequest;
            const positionData = yield getPositionData(id, positionsType);
            if (!positionData || positionData.ERROR) {
                if ((positionData === null || positionData === void 0 ? void 0 : positionData.status) && (positionData === null || positionData === void 0 ? void 0 : positionData.message)) {
                    trackError(context.req, positionData === null || positionData === void 0 ? void 0 : positionData.message);
                    const statusCode = change404ErrorCodeIfNeeded(positionData === null || positionData === void 0 ? void 0 : positionData.status);
                    context.res.statusCode = statusCode;
                    return {
                        props: {
                            translations: superInitialProps.translations,
                            statusCode
                        }
                    };
                }
                throw new InternalServerError(`error fetching position data for position ${id} and type ${positionsType}`, {
                    positionId: id,
                    positionsType
                });
            }
            if (!publishedPositionFitsType(positionData.positionTypeValue, positionsType)) {
                context.res.statusCode = PAGE_GONE_ERROR;
                return {
                    props: {
                        translations: superInitialProps.translations,
                        statusCode: PAGE_GONE_ERROR
                    }
                };
            }
            const props = {
                translations: superInitialProps.translations,
                positionData,
                id,
                asPath: context.req.path,
                statusCode: context.res.statusCode,
                isTypeformDisabled: (_getGeneratorSystemConfigOnRequest = getGeneratorSystemConfigOnRequest(context.req)) === null || _getGeneratorSystemConfigOnRequest === void 0 ? void 0 : _getGeneratorSystemConfigOnRequest.isTypeformDisabled,
                positionsType
            };
            return {
                props: getSerializedServerProps(props)
            };
        } catch (e) {
            yield handleServerException({
                e,
                req: context.req,
                res: context.res,
                bbEventParams: {
                    name: CAREERS_ERROR_RENDERED,
                    kind: POSITION_PAGE
                }
            });
            context.res.statusCode = INTERNAL_SERVER_ERROR_CODE;
            return {
                props: {
                    translations: superInitialProps.translations,
                    statusCode: context.res.statusCode
                }
            };
        }
    });
    return _getServerSideProps.apply(this, arguments);
}
class CareersPositionPage extends BaseTemplatePage {
    render() {
        const { positionData, translations, statusCode } = this.props;
        if (!positionData) return /*#__PURE__*/ _jsx(ErrorCareersComponent, {
            translations: translations,
            statusCode: statusCode
        });
        return /*#__PURE__*/ _jsx(PositionComponent, _object_spread({}, this.props));
    }
}
export { CareersPositionPage as default };
